import { savedLijuPresentation } from "../user/save-liju-presentation.js";
import { isBadge } from "./study-standing-badge.js";

/** Draw one sentence control in its saved or unsaved state. */
export function drawSavedLiju(button: HTMLButtonElement, held: boolean): void {
  button.toggleAttribute("data-cb-saved", held);
  const presentation = savedLijuPresentation({
    label: button.dataset["cbLabel"] ?? "sentence",
    held,
    compactHeld: button.hasAttribute("data-cb-compact-held"),
  });

  const label = button.querySelector<HTMLElement>(".cb-save-liju-label");
  const removeMark = button.querySelector<SVGElement>(
    ".cb-save-liju-remove-mark",
  );

  if (label !== null) {
    label.textContent = presentation.visibleLabel;
    label.classList.toggle("visually-hidden", presentation.iconOnly);
  }

  if (removeMark !== null) {
    removeMark.toggleAttribute("hidden", !presentation.iconOnly);
  }

  // A held corner badge opens its panel rather than removing the sentence.
  // See `study-standing.ts`.
  button.setAttribute(
    "aria-label",
    held && isBadge(button)
      ? `Saved ${button.dataset["cbLabel"] ?? "sentence"}, show your study of it`
      : presentation.accessibleLabel,
  );
}
